import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { apiClient } from 'src/services/api/client';
import type { ISnippet } from 'src/services/api/snippets/types';
import { GET_SNIPPETS_PATH } from 'src/services/api/snippets/constants';

type IUpdateSnippetsOrderResponse = {
    msg: string;
    snippet: ISnippet;
}

type IUpdateSnippetsOrderRequest = {
    order: number[];
    is_private: boolean;
}

export const useUpdateSnippetsOrder = () => {
    const { addNotification } = useNotifications();

    return useMutation<
        IUpdateSnippetsOrderResponse,
        IStandardErrorResponse,
        IUpdateSnippetsOrderRequest
    >(
        (payload) => {
            return apiClient(`${GET_SNIPPETS_PATH}/order`, {
                method: 'put',
                json: payload,
            }).json<IUpdateSnippetsOrderResponse>();
        }, {
            onSuccess: () => {
                addNotification('Snippets order updated successfully', 'success');
            }, onError: (error) => {
                const errorMessage = error.msg || 'Failed to update snippets order';
                addNotification(errorMessage, 'error');
            }
        });
};